import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

export type FeedbackMessageType = 'info' | 'success' | 'warning' | 'error';

@Component({
  selector: 'feedback-message',
  styles: [require('./feedback-message.component.scss')],
  template: `
    <div class="content">
      <div class="text">
        <h1 class="title" *ngIf="title" [innerHTML]="title"></h1>
        <p *ngIf="text" [innerHTML]="text"></p>
      </div>
      <ng-content select=".buttons"></ng-content>
      <button type="button" *ngIf="closable" class="close" (click)="onDismiss()"></button>
    </div>
  `,
})
export class FeedbackMessageComponent {
  @Input() title: string;
  @Input() text: string;
  @Input() closable: boolean = true;
  @Output() dismiss: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.-hidden') @Input() isHidden: boolean;

  public onDismiss() {
    this.isHidden = true;
    this.dismiss.emit();
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/feedback-message/feedback-message.component.ts